<template>
  <div class="centered-container" :style="{ height: height }">
    <img :src="resolvedEmptyImage" alt="空数据提示图片" class="centered-image" :style="{ width: imageWidth }">
    <p class="centered-text">{{ emptyDataText }}</p>
  </div>
</template>

<script>
import emptyimgDefault from "@/assets/img/listempty.png";
import emptyimgList2 from "@/assets/img/listempty2.png";

// 与 H5 端 EmptyImgh5 的 emptyImageType 取值保持一致
const EMPTY_IMAGE_TYPE = {
  DEFAULT: 1,
  LIST_EMPTY_2: 2
};

export default {
  name: 'EmptyImgPc',
  props: {
    // 空数据提示文字
    emptyDataText: {
      type: String,
      default: '列表暂无数据'
    },
    // 自定义图片地址；有值时优先于 emptyImageType
    emptyImage: {
      type: String,
      default: ''
    },
    // 1：listempty；2：listempty2（与 EmptyImgh5 一致）
    emptyImageType: {
      type: Number,
      default: EMPTY_IMAGE_TYPE.DEFAULT
    },
    // 容器高度，默认100px
    height: {
      type: String,
      default: '100px'
    },
    // 图片宽度，默认120px
    imageWidth: {
      type: String,
      default: '120px'
    }
  },
  computed: {
    resolvedEmptyImage() {
      if (this.emptyImage) {
        return this.emptyImage;
      }
      if (this.emptyImageType === EMPTY_IMAGE_TYPE.LIST_EMPTY_2) {
        return emptyimgList2;
      }
      return emptyimgDefault;
    }
  }
}
</script>

<style lang="scss" scoped>
.centered-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.centered-image {
  display: block;
  margin-bottom: 12px;
  object-fit: contain;
}

.centered-text {
  margin: 0;
  font-size: 14px;
  color: #999;
  text-align: center;
  line-height: 1.5;
}
</style>